import Header from './components/Header';
import Hero from './components/Hero';
import Cards from './components/Cards';
import About from './components/About';
import Carousel from './components/Carousel';
import Features from './components/Features';
import Contact from './components/Contact';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import FAQ from './components/FAQ';
import Topics from './components/Topics';
import Index from './components/Index';
import Media from './components/Media';
import Comments from './components/Comments';
import App from './components/App';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Cards />
        <About />
        <Carousel />
        <Features />
        <Contact />
        <Updates />
        <Ranking />
        <FAQ />
        <Topics />
        <Index />
        <Media />
        <Comments />
        <App />
      </main>
      <Footer />
    </>
  );
}